import { Dictionary } from '@utils/util.types';
import { create } from 'zustand/index';

interface IrrigationStore {
	irrigation: Dictionary[];
	setIrrigation: (irrigation: Dictionary[]) => void;
}

export const useIrrigationStore = create<IrrigationStore>((set) => ({
	irrigation: [],
	setIrrigation: (irrigation) => set({ irrigation }),
}));
